/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const changeOrConfigurationErrorEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type ChangeOrConfigurationErrorEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof changeOrConfigurationErrorEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof changeOrConfigurationErrorEnumsAffectedRedundancyLevelOptionEnum];

export type ChangeOrConfigurationErrorEnumsAffectedRedundancyLevelOption =
    ChangeOrConfigurationErrorEnumsAffectedRedundancyLevelOptionEnumKey;
